import React, { useState } from 'react';
import { Typography, Button, Box, Divider } from '@material-ui/core';
import { useParams } from 'react-router-dom';
import clsx from 'clsx';
import { useStoreState } from 'easy-peasy';
import useCaseFetch from 'api/Case';
import { useTranslations } from 'utils/useTranslations';
import { NewMedicalRecordModal } from 'components/Modals/NewMedicalRecordModal';
import usePermissions from 'utils/usePermissions';
import { CaseListItem } from '../PatientCases/types';
import { ParamType } from './types';
import PatientCaseListItem from '../PatientCases/PatientCaseListItem';
import { useStyles } from './styles';
import MedicalRecordListItem from '../MedicalRecordListItem/MedicalRecordListItem';

const PatientCase = () => {
  const intl = useTranslations();
  const styles = useStyles();
  const [open, setOpen] = useState<boolean>(false);
  const [deleteIsLoading, setDeleteIsLoading] = useState<boolean>(false);
  const toggleModal = () => setOpen((old) => !old);
  const { patient, caseId } = useParams<ParamType>();
  const { deleteCase } = useCaseFetch();
  const { canCrudCasesAndRecords } = usePermissions();

  const caseItem: CaseListItem = useStoreState((state) => state.cases.getById(caseId));

  const handleCaseDelete = async () => {
    try {
      setDeleteIsLoading(true);
      await deleteCase(caseId, patient);
      setDeleteIsLoading(false);
    } catch (err) {
      setDeleteIsLoading(false);
    }
  };

  return caseItem ? (
    <Box>
      <Box className={styles.medRecordsHeader}>
        <PatientCaseListItem deleteIsLoading={deleteIsLoading} onDelete={handleCaseDelete} caseItem={caseItem} />
      </Box>
      <Box className={styles.medRecordsContainer}>
        <Box>
          <Typography className={styles.caseHeader}>{intl('medical_records.medical_records')}</Typography>
        </Box>
        <Box>
          {canCrudCasesAndRecords(patient) && (
            <Button className={clsx(styles.addButtonContainer, styles.caseBtnHeaderText)} onClick={toggleModal} variant="contained" color="primary">
              {intl('medical_records.dialog_title')}
            </Button>
          )}
        </Box>
      </Box>
      <Divider />

      {caseItem.medicalRecords.map((item: any) => (
        <MedicalRecordListItem key={item._id} medicalRecord={item} />
      ))}

      <NewMedicalRecordModal open={open} onClose={toggleModal} />
    </Box>
  ) : (
    <></>
  );
};

export default PatientCase;
